import React from "react";
import { graphql } from "gatsby";
import { injectIntl } from "gatsby-plugin-intl";
import PageLayout from "../components/page-layout/PageLayout";

const Journey = ({ data, location }) => {
  return (
    <PageLayout
      {...data.contentfulJourney}
      alternativeBackground
      url={location.href}
    />
  );
};

export default injectIntl(Journey);

export const query = graphql`
  query($slug: String!, $locale: String) {
    contentfulJourney(slug: { eq: $slug }, node_locale: { eq: $locale }) {
      name
      body {
        childMarkdownRemark {
          html
        }
      }
      metaDescription
    }
  }
`;
